/*
	This section is for handling:
	$(selectors[selector]).on(events,handler);
*/
const getSelectorOnHandlers = ({ link, video }) => [
	{
		// Intentionally do not use event delegation here to get around stopPropagation()
		// TODO: We should look into this more. Might be the only thing holding back having this
		// live in getDocumentOnHandlers
		// Perhaps we can figure out why stopPropagation happens when clicking on a mycarsGetAlertsCheckbox selector
		// Or we just go into the MyCars code and have it fire an event directly (using ddcEvent)
		event: 'click',
		selector: 'mycarsGetAlertsCheckbox',
		handler: function handler(e) {
			const $this = $(e.target);
			let eventObject;

			if ($this.is(':checked')) {
				eventObject = link.mycarsGetAlerts($this);
			}
			return eventObject;
		}
	},
	{
		// US358331: handle ws-contact 'get directions' button as a get directions link event
		// TODO: This can probably go in getDocumentOnHandlers but we should test
		// Perhaps it was set up like this due to some OSIRIS thing or something.
		// Maybe the eventDelegation won't work. Not sure.
		event: 'submit',
		selector: 'getDirectionsForm',
		handler: link.getDirections
	},
	// TODO: The three below video events can probably go in getDocumentOnHandlers
	{
		// Fires when play is clicked on HTML5 video
		event: 'play',
		selector: 'video',
		handler: video.play
	},
	{
		event: 'timeupdate',
		selector: 'video',
		handler: video.milestones.track
	},
	{
		event: 'ended',
		selector: 'video',
		handler: video.milestones.complete
	}
];

export default getSelectorOnHandlers;
